import { render } from "./detail.vue?vue&type=template&id=4ec821ad&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=4ec821ad&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec821ad"]])

export default __exports__